(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/upcoming-events/assets/javascripts/use-get-tournament-events.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/upcoming-events/assets/javascripts/use-get-tournament-events.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const _svs$core = svs.core,
  jupiter = _svs$core.jupiter,
  log = _svs$core.log;
const TournamentFetchMoreCount = svs.poker_react.components.common.constants.TournamentFetchMoreCount;
const logger = log.getLogger('module:poker_react:components:upcoming_events:get_tournaments');
const fetchTournaments = async (activeFilters, offset) => {
  const qs = new URLSearchParams();
  if (activeFilters.tournamentType === 'poker-sm') {
    qs.append('PokerSMType', activeFilters.satellite);
  } else {
    if (activeFilters.gameType !== null) {
      qs.append('gameType', activeFilters.gameType);
    }
    if (activeFilters.buyin.id !== null) {
      qs.append('minTotalBuyIn', activeFilters.buyin.min);
      qs.append('maxTotalBuyIn', activeFilters.buyin.max);
    }
  }
  qs.append('offset', offset);
  qs.append('count', offset === 0 ? 5 : TournamentFetchMoreCount);
  try {
    const _await$jupiter$callAs = await jupiter.callAsync({
        method: 'GET',
        path: "/poker/2/tournaments/".concat(activeFilters.tournamentType, "/upcoming?").concat(qs.toString())
      }),
      response = _await$jupiter$callAs.response;
    return {
      moreItems: response.moreItems,
      tournaments: response.tournaments.map(tournament => _objectSpread(_objectSpread({}, tournament), {}, {
        tournamentId: tournament.id,
        buyIn: tournament.totalBuyIn
      }))
    };
  } catch (error) {
    logger.error("Error fetching poker events: ".concat(error));
    return {
      error
    };
  }
};
const useGetTournamentEvents = (activeFilters, offset) => {
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    tournaments = _useState2[0],
    setTournaments = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    moreItems = _useState4[0],
    setMoreItems = _useState4[1];
  const _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    shouldShowSkeleton = _useState6[0],
    setShouldShowSkeleton = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFetchingMore = _useState8[0],
    setIsFetchingMore = _useState8[1];
  const _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    error = _useState0[0],
    setError = _useState0[1];
  const prevOffset = useRef(null);
  useEffect(() => {
    const isFetchMore = prevOffset.current !== offset && offset > 0;
    if (isFetchMore) {
      setIsFetchingMore(true);
    } else {
      prevOffset.current = 0;
      setShouldShowSkeleton(true);
    }
    async function fetchData() {
      setError(null);
      const results = await fetchTournaments(activeFilters, offset);
      if (results.error) {
        setError(results.error);
        setTournaments([]);
        setMoreItems(false);
        setShouldShowSkeleton(false);
        return;
      }
      let newTournaments = results.tournaments;
      if (isFetchMore) {
        newTournaments = [...tournaments, ...results.tournaments];
        prevOffset.current = offset;
      }
      setTournaments(newTournaments);
      setMoreItems(results.moreItems);
      if (isFetchMore) {
        setIsFetchingMore(false);
      } else {
        setShouldShowSkeleton(false);
      }
    }
    fetchData();
  }, [activeFilters, offset]);
  return {
    tournaments,
    moreItems,
    shouldShowSkeleton,
    error,
    isFetchingMore
  };
};
setGlobal('svs.poker_react.components.upcomingEvents.useGetTournamentEvents', useGetTournamentEvents);

 })(window);